import { useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

import {
    FaUserShield,
    FaUser,
    FaLock,
    FaEye,
    FaEyeSlash,
    FaSchool
} from "react-icons/fa";

export default function Login() {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const handleLogin = async () => {

        try {

            setLoading(true);

            const res = await API.post("/auth/login", {
                username,
                password,
            });

            localStorage.setItem("token", res.data.token);
            localStorage.setItem("role", res.data.role);

            localStorage.setItem(
                "username",
                res.data.user.username
            );

            const permissionsRes = await API.get(
                `/permissions/${res.data.user.id}`
            );

            const permissionNames = permissionsRes.data.map(
                (item) => item.permission_name
            );

            localStorage.setItem(
                "permissions",
                JSON.stringify(permissionNames)
            );

            if (res.data.mustChangePassword) {

                navigate("/change-password");

                return;

            }

            if (permissionNames.includes("dashboard")) {
                navigate("/dashboard");
            }
            else if (permissionNames.includes("students")) {
                navigate("/students");
            }
            else if (permissionNames.includes("fees")) {
                navigate("/fees");
            }
            else if (permissionNames.includes("attendance")) {
                navigate("/attendance");
            }
            else if (permissionNames.includes("staff")) {
                navigate("/staff");
            }
            else if (permissionNames.includes("salary")) {
                navigate("/salary");
            }
            else if (permissionNames.includes("exam_marks")) {
                navigate("/exam-marks");
            }
            else if (permissionNames.includes("notifications")) {
                navigate("/notifications");
            }
            else if (permissionNames.includes("transport")) {
                navigate("/transport");
            }
            else {

                alert("No module access assigned");

                localStorage.removeItem("token");
                localStorage.removeItem("role");
                localStorage.removeItem("permissions");

                navigate("/");
            }

        } catch (err) {

            if (err.response?.data?.msg) {
                alert(err.response.data.msg);
            }
            else {
                alert("Something went wrong");
            }

        } finally {
            setLoading(false);
        }
    };

    return (

        <div className="min-h-screen flex bg-gray-100">

            {/* Left Branding Section */}
            <div className="hidden lg:flex w-1/2 bg-blue-900 text-white flex-col justify-center items-center p-16">

                <div className="bg-white/10 p-6 rounded-full mb-8">
                    <FaSchool className="text-7xl" />
                </div>

                <h1 className="text-5xl font-bold mb-5 text-center">
                    School ERP
                </h1>

                <p className="text-xl text-blue-100 text-center leading-relaxed max-w-lg">
                    Modern enterprise platform for complete school
                    administration, academics, finance, transport,
                    staff management, and analytics.
                </p>

                <div className="mt-12 grid grid-cols-2 gap-6 w-full max-w-lg">

                    <div className="bg-white/10 p-5 rounded-2xl">
                        <h2 className="text-3xl font-bold">
                            1000+
                        </h2>

                        <p className="text-blue-100 mt-1">
                            Students Managed
                        </p>
                    </div>

                    <div className="bg-white/10 p-5 rounded-2xl">
                        <h2 className="text-3xl font-bold">
                            99%
                        </h2>

                        <p className="text-blue-100 mt-1">
                            Attendance Accuracy
                        </p>
                    </div>

                    <div className="bg-white/10 p-5 rounded-2xl">
                        <h2 className="text-3xl font-bold">
                            ERP
                        </h2>

                        <p className="text-blue-100 mt-1">
                            Enterprise Grade
                        </p>
                    </div>

                    <div className="bg-white/10 p-5 rounded-2xl">
                        <h2 className="text-3xl font-bold">
                            Secure
                        </h2>

                        <p className="text-blue-100 mt-1">
                            Role Based Access
                        </p>
                    </div>

                </div>

            </div>

            {/* Login Section */}
            <div className="flex-1 flex justify-center items-center p-6">

                <div className="bg-white shadow-2xl rounded-3xl w-full max-w-md p-10">

                    <div className="text-center mb-8">

                        <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-5">

                            <FaUserShield className="text-4xl text-blue-700" />

                        </div>

                        <h2 className="text-4xl font-bold text-gray-800">
                            Welcome Back
                        </h2>

                        <p className="text-gray-500 mt-2">
                            Login to continue to School ERP
                        </p>

                    </div>

                    {/* Username */}
                    <div className="mb-5">

                        <label className="block mb-2 font-semibold text-gray-700">
                            Username
                        </label>

                        <div className="flex items-center border rounded-xl px-4 py-3 bg-gray-50">

                            <FaUser className="text-gray-400 mr-3" />

                            <input
                                type="text"
                                placeholder="Enter username"
                                value={username}
                                onChange={(e) =>
                                    setUsername(e.target.value)
                                }
                                className="w-full bg-transparent outline-none"
                            />

                        </div>

                    </div>

                    {/* Password */}
                    <div className="mb-6">

                        <label className="block mb-2 font-semibold text-gray-700">
                            Password
                        </label>

                        <div className="flex items-center border rounded-xl px-4 py-3 bg-gray-50">

                            <FaLock className="text-gray-400 mr-3" />

                            <input
                                type={
                                    showPassword
                                        ? "text"
                                        : "password"
                                }
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) =>
                                    setPassword(e.target.value)
                                }
                                className="w-full bg-transparent outline-none"
                            />

                            <button
                                type="button"
                                onClick={() =>
                                    setShowPassword(!showPassword)
                                }
                            >
                                {showPassword
                                    ? <FaEyeSlash className="text-gray-500" />
                                    : <FaEye className="text-gray-500" />
                                }
                            </button>

                        </div>

                    </div>

                    {/* Login Button */}
                    <button
                        onClick={handleLogin}
                        disabled={loading}
                        className="w-full bg-blue-700 hover:bg-blue-800 transition text-white py-3 rounded-xl font-semibold text-lg"
                    >

                        {loading
                            ? "Signing In..."
                            : "Login"
                        }

                    </button>

                    {/* Footer */}
                    <div className="mt-8 text-center text-gray-400 text-sm">
                        Enterprise School Management Platform
                    </div>

                </div>

            </div>

        </div>
    );
}